import { render, staticRenderFns } from "./EditarTablaNoSeriados.vue?vue&type=template&id=2705475d&"
import script from "./EditarTablaNoSeriados.vue?vue&type=script&lang=ts&"
export * from "./EditarTablaNoSeriados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports